module.exports = __webpack_public_path__ + "img/goods12_6.3ba4a639.jpg";